function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 88.5,
  r: 88.5,
  fill: "#FDC134"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.936 46.823h33.712c20.506 0 36.05 11.022 41.833 27.06h10.502v9.694h-8.29c.162 1.532.245 3.092.245 4.678v.238a44.4 44.4 0 01-.31 5.259h8.355v9.694h-10.702c-5.935 15.815-21.358 26.732-41.633 26.732H54.936v-26.732H43.22v-9.694h11.715V83.577H43.22v-9.694h11.715v-27.06zm9.425 56.623v18.036h24.287c14.988 0 26.123-7.224 31.307-18.036H64.361zm58.481-9.694H64.361V83.577h58.496a36.59 36.59 0 01.328 4.916v.238c0 1.712-.116 3.389-.343 5.02zM88.648 55.505c15.057 0 26.226 7.414 31.378 18.378H64.361V55.505h24.287z",
  fill: "#fff"
});

function SvgDai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177 177",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/DAI.97b90baa.svg";
export { ForwardRef as ReactComponent };